module.exports = __webpack_public_path__ + "img/ml3064.13fcbc61.png";